export interface AcademyDetailsStepCompleteInput {
  academyName?: string | null;
  timezone?: string | null;
  requireTimezone?: boolean;
  termsAccepted?: boolean | null;
  privacyAccepted?: boolean | null;
  isSocialLogin: boolean;
  countryBlocked: boolean;
}

/** Whether the academy-details onboarding step can proceed. */
export function isAcademyDetailsStepComplete({
  academyName,
  timezone,
  requireTimezone = true,
  termsAccepted,
  privacyAccepted,
  isSocialLogin,
  countryBlocked,
}: AcademyDetailsStepCompleteInput): boolean {
  const hasName = Boolean(academyName?.trim());
  const hasTimezone = !requireTimezone || Boolean(timezone?.trim());
  const legalOk =
    !isSocialLogin || (termsAccepted === true && privacyAccepted === true);
  return hasName && hasTimezone && legalOk && !countryBlocked;
}
